/**
 * Chromium 66 shims — the Sunmi L2s WebView floor (see .browserslistrc).
 *
 * esbuild downlevels *syntax* for the configured target but never runtime *APIs*. Every entry
 * below was proven missing from a built bundle; core-js entry points are per-feature, so only
 * these ship rather than the whole library. Angular emits this as a separate polyfills-HASH.js
 * injected before main-HASH.js, and module scripts evaluate in document order — so the shims
 * land before any Angular or dependency chunk runs.
 *
 * Re-verify against a built bundle after any dependency bump; a new lazy route can pull in an
 * API that tree-shaking kept out of today's bundle.
 */
import 'core-js/es/global-this'; // 71 — Angular emits a bare top-level `var x = globalThis`
import 'core-js/web/queue-microtask'; // 71 — Angular's zoneless scheduler
import 'core-js/es/array/flat'; // 69 — @angular/router
import 'core-js/es/array/flat-map'; // 69 — @angular/forms
import 'core-js/es/promise/all-settled'; // 76 — @angular/core
import 'core-js/es/array/at'; // 92 — a dependency in main-*.js; no longer used in src/
import 'core-js/es/object/has-own'; // 93 — @angular/{core,common,forms,router}
